import {
    CS_BASE_URL as CS_GRAPHQL_BASE_URL,
    NEW_CS_BASE_URL as CS_CONTENT_BASE_URL,
} from './ProjectUrls';
import { LinkCollectionEntry } from '../graphql/pimcore/modules/siteContent/types/SiteContentElement';
export const PIMCORE_CONTENT_BASE_URL = `${CS_CONTENT_BASE_URL}/content`;

export const GRAPHQL_API_KEY = process.env.NEXT_PUBLIC_PIMCORE_GRAPHQL_API_KEY;

interface GraphqlEndpointConfig {
    /** If true, hits the pimcore server directly, not proxied through the backend server */
    direct?: boolean;
    /** Only honoured when `direct === false` */
    cached?: boolean;
}

export function getGraphqlEndpoint({
    direct = false,
    cached = false,
}: GraphqlEndpointConfig = {}): string {
    if (direct) {
        const endpoint = 'https://pimcore-dev.yageogroup.com/pimcore-graphql-webservices';
        return `${endpoint}/public-content?apikey=${GRAPHQL_API_KEY}`;
    } else {
        // return `${CS_GRAPHQL_BASE_URL}/graphql/pimcore`;

        return `${CS_GRAPHQL_BASE_URL}/graphql/pimcore${cached ? '?cached=true' : ''}`;
    }
}

// This function is used to get the full URL of an asset from the asset full path, that is
// for example provided by following properties
// - ResourceLibraryItemBase.thumbnailUrl (common for all resource library item types)
// - ResourceLibraryAssetItem.asset.fullpath
// - ResourceLibraryNewsItem.coverImageUrl
export function getAssetUrl(assetPath: string | null | undefined): string | undefined {
    if (!assetPath) {
        return undefined;
    }
    return `${PIMCORE_CONTENT_BASE_URL}${assetPath}`;
}

export const getLinkURLFromPimcore = (
    link?: LinkCollectionEntry,
    defaultFallback: string = '#' // 帶預設值 → 不再違反 TS1016
): string => {
    if (!link) return defaultFallback;

    const resolved = link.kind === 'externalLinkFieldCollection' ? link.linkUrl : link.linkRoute;

    // 若 resolved 為 null / undefined / 空字串，亦回傳 fallback
    return resolved && resolved.length > 0 ? resolved : defaultFallback;
};

export const getLinkTextFromPimcore = (
    link?: LinkCollectionEntry,
    defaultFallback: string = '#' // 帶預設值 → 不再違反 TS1016
): string => {
    if (!link) return defaultFallback;
    return link.linkText || defaultFallback;
};
